import { ComponentType, FunctionComponent, useContext } from "react";
import { Subtract } from "utility-types";

import { IWithSearchContextProps } from "./IWithSearchContextProps";
import { SearchContext } from "./SearchContext";

export function WithSearchContext<P extends IWithSearchContextProps>(
  Component: ComponentType<P>
): FunctionComponent<Subtract<P, IWithSearchContextProps>> {
  function ComponentWithContext(props: Subtract<P, IWithSearchContextProps>) {
    const context = useContext(SearchContext);
    return <Component {...(props as P)} {...context} />;
  }

  const componentName = Component.displayName ?? Component.name ?? `Component`;
  ComponentWithContext.displayName = `WithSearchContext(${componentName})`;
  return ComponentWithContext;
}
